export enum SFM_SOURCES {
  LINE_BOARD = 0,
  SFM_BOARD = 1,
}
